import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const sumSquaredErrorsDescription: CalculatorDescription = {
  id: CalculatorId.SUM_SQUARED_ERRORS,
  title: 'Sum of Squared Errors (SSE) Calculator',
  metaTitle: 'Sum of Squared Errors (SSE) Calculator - Measure Data Variability',
  description: 'Calculate the Sum of Squared Errors (SSE) for your dataset. Measure the total squared deviation from the mean for statistical analysis.',
  metaDescription: 'Free online Sum of Squared Errors (SSE) calculator. Find the total squared deviation from the mean to analyze data variability and model fit.',
  howTo: {
    title: 'How to Calculate Sum of Squared Errors',
    steps: [
      'Enter your numeric data into the data table or upload a CSV file',
      'Select the column of data you want to analyze',
      'The calculator will compute the mean of your data',
      'The sum of squared errors (total squared deviations from the mean) will be calculated',
      'View a breakdown of each value with its deviation and squared deviation'
    ]
  },
  examples: [
    {
      title: 'Analyzing Model Fit',
      description: 'Calculate SSE to evaluate how well a model fits the data',
      dataDescription: 'Sample data: 15, 18, 22, 24, 27, 30, 33, 35, 38, 42',
      insights: [
        'SSE measures the total squared deviation from the mean',
        'Lower SSE values indicate data points are closer to the mean',
        'SSE is used to evaluate goodness of fit in regression models',
        'SSE is used in calculating R-squared and variance'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.VARIANCE,
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN,
    CalculatorId.COEFFICIENT_OF_DETERMINATION
  ]
}; 